import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { CreateCategoryDto, UpdateCategoryDto } from '@/types';

// Lista dedicada para la pagina de Configuracion. La info tambien
// vive en /api/catalogs.categories pero ese cache lo invalidamos
// igual cuando hay mutations para que el resto de la app vea los
// cambios al toque.
export function useCategorias() {
  return useQuery({
    queryKey: ['categories'],
    queryFn: api.categories.list,
  });
}

function bumpAll(qc: ReturnType<typeof useQueryClient>) {
  qc.invalidateQueries({ queryKey: ['categories'] });
  qc.invalidateQueries({ queryKey: ['catalogs'] });
}

export function useCreateCategoria() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreateCategoryDto) => api.categories.create(dto),
    onSuccess: () => bumpAll(qc),
  });
}

export function useUpdateCategoria() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, dto }: { id: number; dto: UpdateCategoryDto }) =>
      api.categories.update(id, dto),
    onSuccess: () => bumpAll(qc),
  });
}

export function useDeleteCategoria() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.categories.remove(id),
    onSuccess: () => bumpAll(qc),
  });
}

export function useReorderCategorias() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (orderedIds: number[]) => api.categories.reorder(orderedIds),
    onSuccess: () => bumpAll(qc),
  });
}
